import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogInIcon } from 'lucide-react';
import { LoadingScreen } from '../components/LoadingScreen';
import { useAuth } from '../contexts/AuthContext';
export function Login() {
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate loading time for dashboard data
    setTimeout(() => {
      login();
      navigate('/overview');
    }, 2000);
  };
  if (isLoading) {
    return <LoadingScreen data-id="element-4565" />;
  }
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex items-center justify-center px-4" data-id="element-4566">
      <div className="max-w-md w-full" data-id="element-4567">
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-8" data-id="element-4568">
          <div className="flex justify-center mb-6" data-id="element-4569">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/c3ZBwzojuSYrA5qxKsGMb1/logo_geniebusiness.svg" alt="Genie Business" className="h-16" data-id="element-4570" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-2" data-id="element-4571">
            Welcome Back
          </h2>
          <p className="text-gray-600 text-center mb-8" data-id="element-4572">
            Sign in to your account to continue
          </p>
          <form onSubmit={handleLogin} className="space-y-6" data-id="element-4573">
            <div data-id="element-4574">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4575">
                Email Address
              </label>
              <input type="email" placeholder="simon.verraest@geniebusiness.lk" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" data-id="element-4576" />
            </div>
            <div data-id="element-4577">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4578">
                Password
              </label>
              <input type="password" placeholder="••••••••" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" data-id="element-4579" />
            </div>
            <div className="flex items-center justify-between" data-id="element-4580">
              <label className="flex items-center" data-id="element-4581">
                <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-4582" />
                <span className="ml-2 text-sm text-gray-600" data-id="element-4583">Remember me</span>
              </label>
              <button type="button" className="text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-4584">
                Forgot password?
              </button>
            </div>
            <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center" data-id="element-4585">
              <LogInIcon size={18} className="mr-2" data-id="element-4586" />
              Sign In
            </button>
          </form>
          <div className="mt-6 text-center" data-id="element-4587">
            <p className="text-sm text-gray-600" data-id="element-4588">
              Don't have an account?{' '}
              <button className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-4589">
                Contact Sales
              </button>
            </p>
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-4590">
          <p className="text-sm text-gray-500" data-id="element-4591">
            © 2024 Genie Business. All rights reserved.
          </p>
        </div>
      </div>
    </div>;
}